// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaigns-header {
  min-height: 60px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.campaigns-header .campaigns-header-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
}
.campaigns-header .campaigns-lastupdate {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.campaigns-header .campaigns-search-box {
  color: #6A8991;
  font-size: 17px;
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.campaigns-header .campaigns-search-box .campaigns-search-input {
  background-color: transparent;
  border: 0;
  outline: 0;
  font-size: 17px;
  color: #6A8991;
  height: 30px;
}

.related-accounts-tooltip {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 250px; /* Made it wider */
  padding: 12px;
  background-color: #f9f9f9; /* Brighter background */
  border-radius: 8px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  font-size: 16px; /* Bigger text */
}

.related-account-item {
  padding: 6px 0;
  border-bottom: 1px solid #ddd;
}

.related-account-item:last-child {
  border-bottom: none;
}

.related-account-link {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px; /* Bigger font */
}

.related-accounts-icon {
  color: #007bff;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px; /* Bigger icon */
  padding: 6px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Campaigns/CampaignMembers/CampaignMembers.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACD;AACC;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AACF;AAEC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAAF;AAGC;EACC,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AADF;AAGE;EACC,6BAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AADH;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA,EAAA,kBAAA;EACA,aAAA;EACA,yBAAA,EAAA,wBAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA,EAAA,gBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,6BAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA,EAAA,gBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA,EAAA,gBAAA;EACA,YAAA;AAHJ","sourcesContent":[".campaigns-header {\n\tmin-height: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 10px;\n\n\t.campaigns-header-buttons {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tmargin-right: 20px;\n\t}\n\n\t.campaigns-lastupdate {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t}\n\n\t.campaigns-search-box {\n\t\tcolor: #6A8991;\n\t\tfont-size: 17px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-left: 10px;\n\n\t\t.campaigns-search-input {\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 0;\n\t\t\toutline: 0;\n\t\t\tfont-size: 17px;\n\t\t\tcolor: #6A8991;\n\t\t\theight: 30px;\n\t\t}\n\t}\n}\n\n.related-accounts-tooltip {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    min-width: 250px; /* Made it wider */\n    padding: 12px;\n    background-color: #f9f9f9; /* Brighter background */\n    border-radius: 8px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);\n    font-size: 16px; /* Bigger text */\n}\n\n.related-account-item {\n    padding: 6px 0;\n    border-bottom: 1px solid #ddd;\n}\n\n.related-account-item:last-child {\n    border-bottom: none;\n}\n\n.related-account-link {\n    color: #007bff;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: 14px; /* Bigger font */\n}\n\n.related-accounts-icon {\n    color: #007bff;\n    font-weight: bold;\n    cursor: pointer;\n    font-size: 14px; /* Bigger icon */\n    padding: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
